
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlertheaderAggregatedIec as ObiAlertheaderAggregatedIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alertheader-aggregated-iec.js';
 
 
 

 
 export const ObiAlertheaderAggregatedIec = createComponent({
   react: React,
   tagName: 'obi-alertheader-aggregated-iec',
   elementClass: ObiAlertheaderAggregatedIecElement,
   events: {
     
   }
  });
 
 